import { Flex, Text, Em } from "@radix-ui/themes";
import { CodeBlock } from "@/components/shared/code-block/CodeBlock";

const AVAILABLE_METHODS_CODE = `// User identification
quack.identify({ id: 'user-id', email: 'user@example.com' });
quack.getIdentify(); // Get current user info
quack.logout(); // Logout current user

// Chat visibility
quack.showChat(); // Show the chat widget
quack.hideChat(); // Hide the chat widget
quack.minimizeChat(); // Minimize the chat
quack.expandChat(); // Expand the chat
quack.alignChat('bottom-left' | 'bottom-right'); // Align chat position


// Tracking
quack.trackCallback((eventName, properties) => {
  // Custom tracking callback
});

// Error & Auth handlers
quack.addErrorHandler((error) => {
  // Handle errors
});

// Load a new token + new onReady function
quack.reload('new-token', (quack) => {
  quack.identify({
    id: 'test-id',
    email: 'test@email.com'
  });
  quack.showChat();
});`;

export function AvailableMethods() {
  return (
    <Flex direction={"column"} gap={"3"} pt={"40px"}>
      <Text size={"2"} color={"gray"} weight={"medium"} highContrast>
        Available Methods
      </Text>

      <Text size={"2"} color={"gray"}>
        <Em>
          Once the Quack instance is available in the onReady callback, you can
          use the following methods:
        </Em>
      </Text>

      <Flex direction={"column"} gap={"2"}>
        <CodeBlock
          code={AVAILABLE_METHODS_CODE}
          language="javascript"
          showLineNumbers={false}
        />
      </Flex>
    </Flex>
  );
}
